export const isUserExistsSelector = ({ currentUser: { user } }) => !!user

export const isUserProfileFilledSelector = ({ currentUser: { user } }) => {
  if (!user) {
    return false
  }

  return user.isProfileFilled
}
